import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import '@popperjs/core';
import { useTitle } from '../../utils/useTitle/useTitle.esm.js';
import { LoadingPage } from './LoadingPage.esm.js';

/**
 * Helps layout controls of a page.
 * Will handle spacing of common page elements.
 */
function PageLayout({ children, documentTitle, header, isLoading = false, tabList, filterBar, noPadding = false, noMargin = false, overflow = false, addClassName = '' }) {
    useTitle(documentTitle);
    if (noPadding || overflow) {
        console.warn('noPadding and overflow props has been deprecated and will be ignored!');
    }
    return (React.createElement("div", { className: classNames('tw-flex tw-flex-col tw-w-full tw-bg-gray-50 dark:tw-bg-gray-1000', addClassName) },
        React.createElement("div", { className: "tw-border-solid tw-border-0 tw-border-b tw-border-gray-300 dark:tw-border-gray-950" }, header),
        tabList && React.createElement("div", null, tabList),
        filterBar && React.createElement("div", null, filterBar),
        React.createElement("div", { className: noMargin ? '' : 'tw-m-4' }, isLoading ? React.createElement(LoadingPage, null) : children)));
}

export { PageLayout };
//# sourceMappingURL=PageLayout.esm.js.map
